import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { WindowRef } from '@boels/helpers';

@Injectable()
export class CanonicalLinkService {
  private winRef = inject(WindowRef);
  private rendererFactory = inject(RendererFactory2);

  private readonly renderer: Renderer2;

  constructor() {
    const rendererFactory = this.rendererFactory;

    this.renderer = rendererFactory.createRenderer(null, null);
  }

  removeCanonical(): void {
    const canonicalLink: Element | null =
      this.winRef.document.head.querySelector('link[rel=canonical]');
    if (canonicalLink) {
      this.renderer.removeChild(canonicalLink.parentNode, canonicalLink);
    }
  }

  setCanonical(value: string): void {
    const canonicalLink: Element | null =
      this.winRef.document.head.querySelector('link[rel=canonical]');
    if (canonicalLink) {
      // update canonical link if already exists
      canonicalLink.setAttribute('href', value);
    } else {
      // create actual canonical link if not exist
      const link: HTMLLinkElement = this.renderer.createElement('link');
      if (value.endsWith('/')) {
        value = value.slice(0, -1);
      }
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', value);
      this.renderer.appendChild(this.winRef.document.head, link);
    }
  }
}
